import { render, staticRenderFns } from "./LedgerBookView.vue?vue&type=template&id=29824adf&scoped=true"
import script from "./LedgerBookView.vue?vue&type=script&lang=js"
export * from "./LedgerBookView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29824adf",
  null
  
)

export default component.exports